import BaseModelAPI from '../BaseModelAPI';

export default class OutgoingDocumentStatus extends BaseModelAPI {
	static entity = 'outgoingdocumentstatus';
	static entityName = 'outgoingdocumentstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}